import React from 'react'

import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'
import { reviewStyles } from './styles'
import { AreaContainer } from '../styles'
import BuildListItem from '../BuildListItem'

export default function ReviewsList({
  reviews,
  reviewCheckType,
  splitReviewsByArea,
  onDataChanged,
}) {
  const classes = makeStyles(() => reviewStyles)()

  const splitAreas = (issues) => {
    const rh = []
    const compliance = []

    issues.forEach((issue) => {
      if (issue.user_role === 'Recursos Humanos') rh.push(issue)
      if (issue.user_role === 'Compliance') compliance.push(issue)
    })

    return { rhReviews: rh, complianceReviews: compliance }
  }

  const { rhReviews, complianceReviews } = splitAreas(reviews)

  const renderReviewsSplittedByArea = () => (
    <React.Fragment>
      <AreaContainer>
        <h3 style={{ color: Colors.rhBlue }}>
          Revisão necessária dos Recursos Humanos:
        </h3>
        {rhReviews.map((issue) => {
          return (
            <BuildListItem
              key={issue.uuid}
              issue={issue}
              checkType={reviewCheckType}
              onDataChanged={onDataChanged}
            />
          )
        })}
      </AreaContainer>
      <AreaContainer>
        <h3 style={{ color: Colors.compliancePurple }}>
          Revisão necessária do Compliance:
        </h3>
        {complianceReviews.map((issue) => {
          return (
            <BuildListItem
              key={issue.uuid}
              issue={issue}
              checkType={reviewCheckType}
              onDataChanged={onDataChanged}
            />
          )
        })}
      </AreaContainer>
    </React.Fragment>
  )

  const renderReviewsTogether = () =>
    reviews.map((issue) => {
      return (
        <BuildListItem key={issue.uuid} issue={issue} checkType={reviewCheckType} onDataChanged={onDataChanged} />
      )
    })

  return (
    <div className={classes.gappedItem}>
      <h3>Conteúdo da Revisão</h3>

      {splitReviewsByArea &&
      rhReviews.length > 0 &&
      complianceReviews.length > 0
        ? renderReviewsSplittedByArea()
        : renderReviewsTogether()}
    </div>
  )
}
